module.exports = __webpack_public_path__ + "img/vege_trading.4070b64d.jpg";